export default {
  root: {
    width: 212,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 2,
    m: 3,
    position: 'sticky',
    top: 'calc(24px + 64px)',
    height: 'calc(100vh - 24px - 24px - 64px)',
  },
  lightRoot: {
    backgroundColor: 'background.white',
  },
  darkRoot: {
    backgroundColor: 'background.dark',
  },
  list: {
    py: 3,
    px: 1.5,
  },
};
